import * as React from "react";
import { forwardRef } from "react";
const ReactComponent = ({ title, titleId, ...props }, ref) => React.createElement("svg", { "data-testid": "checkmark-circle-17", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 17 17", ref: ref, "aria-labelledby": titleId, ...props },
    title ? React.createElement("title", { id: titleId }, title) : null,
    React.createElement("path", { fill: "currentColor", fillOpacity: 0.2, fillRule: "evenodd", d: "M8.5 2a6.5 6.5 0 1 1 0 13 6.5 6.5 0 0 1 0-13z" }),
    React.createElement("path", { fill: "currentColor", d: "M10.595 6.207a.5.5 0 0 1 .81.586l-3.25 4.5a.5.5 0 0 1-.8.014l-1.75-2.25a.5.5 0 1 1 .79-.614l1.339 1.723z" }));
const ForwardRef = forwardRef(ReactComponent);
export { ForwardRef as ReactComponent };
